import type { Child } from '@baby-tracker/contracts';
import { useState } from 'react';

const STORAGE_KEY = 'activeChildId';

function readStoredChildId(): string | null {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
}

/** The child the logger is aimed at. The id is not a secret; access is still checked by the API. */
export function useActiveChild(children: Child[] | undefined): {
    activeChild: Child | undefined;
    setActiveChildId: (childId: string) => void;
} {
    const [selectedId, setSelectedId] = useState<string | null>(readStoredChildId);
    const activeChild = children?.find((child) => child.id === selectedId) ?? children?.[0];

    function setActiveChildId(childId: string): void {
        try {
            localStorage.setItem(STORAGE_KEY, childId);
        } catch {
            // Storage can be unavailable in private mode. The selection still applies for this visit.
        }
        setSelectedId(childId);
    }

    return { activeChild, setActiveChildId };
}
